import common from './common';
import uiv from './uiv';
import element from './element';
import catalog from './catalog';
import validate from './vee-validate';
import organization from './organization';
import home from './home';
import dashboard from './dashboard';
import account from './account/';
import auth from './auth/';
import buyer from './buyer/';
import routes from './routes/';
import layouts from './layouts';
import reports from './reports';
import rfi from './rfi';
import error from './error';
import cataloger from './cataloger/';

export default {
  cat4mro: {
    breadcrumbs: {
      root: 'CAT4MRO',
      search: 'Búsqueda',
    },
  },
  ...account,
  ...auth,
  ...buyer,
  ...layouts,
  ...routes,
  ...reports,
  ...uiv,
  ...element,
  ...common,
  ...catalog,
  ...validate,
  ...organization,
  ...home,
  ...dashboard,
  ...rfi,
  ...error,
  ...cataloger,
};



// WEBPACK FOOTER //
// ./src/i18n/es-cl/index.js